import FusePageSimple from "@fuse/core/FusePageSimple";
import _ from "@lodash";
import { styled } from "@mui/material/styles";
import { Card } from "@mui/material";
import BulkPetUploadComponent from "./components/BulkPetUpload/BulkPetUploadComponent";

const Root = styled(FusePageSimple)(({ theme }) => ({
	"& .FusePageSimple-header": {
		backgroundColor: theme.palette.background.paper,
		boxShadow: `inset 0 0 0 1px  ${theme.palette.divider}`,
	},
}));

/**
 * The ProjectDashboardApp page.
 */
function BulkPetUoloadApp() {

	return (
		<div className="w-full p-[20px]">
			<div className="flex flex-col gap-[20px]">
				<Card className="p-[28px] overflow-hidden">
					<BulkPetUploadComponent/>
				</Card>
			</div>		
		</div>
		
	);
}

export default BulkPetUoloadApp;
